import {useStateValue} from "./state";
import React, {useState, useEffect} from "react";
import ReactJson from 'react-json-view';

import Lookup from "./Lookup";
import {getItems} from './data';

export const RenderItem = () => {
    const [{connection}, ] = useStateValue();
    const [{metadata}, ] = useStateValue();
    const [{operation}, dispatch] = useStateValue();

    const KeySchema = metadata.Table.KeySchema;

    const pkName = KeySchema[0].AttributeName;
    const skName = KeySchema[1] ? KeySchema[1].AttributeName : null;

    const [items, setItems] = useState([]);


    useEffect( () => {

        dispatch({type: 'appendLog', newMsg: 'get()' });

        const fetchData = async () => {
            const data = await getItems(connection, operation, [pkName, skName]);
            if(data.ConsumedCapacity) {
                dispatch({type: 'appendLog', newMsg: 'Consumed RCUs: ' + data.ConsumedCapacity.CapacityUnits});
            }
            if(data) {
                setItems([data]);
            }
        };

        if(operation.pk) {
            fetchData();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[operation.pk + operation.sk]);


    // console.log('items :::');
    // console.log(JSON.stringify(items, null, 2));


    // if(items.length === 0 || Object.keys(items[0]).length === 0 ) {
    if( (!items || items.length === 0 || !items[0].Item)  ) {

        if(items.length === 0) {
            return (<Lookup />);

        } else {
            return(<div>
                <Lookup />
                <br/>0 records found.<br/>
            </div>);
        }


    } else {

        const item = items[0].Item;

        // const attrMap = Object.keys(item || null);

        const attrMap = Object.keys(item || null).filter((item) => {
            return item !== pkName && item !== skName;
        });


        attrMap.sort((a,b) => {
            let ta = a;
            let tb = b;
            if(typeof item[a] === 'object') {ta = 'zzzzz';}
            if(typeof item[b] === 'object') {tb = 'zzzzz';}
            return (tb > ta ? -1 : 1);
        });

        const attrMap2 = attrMap.map((key) => {
            // console.log(`${key} : ${item[key]}`);
            let attrValue = item[key];

            if(item[key] && typeof item[key] === 'object') {

                attrValue = (<ReactJson src={item[key]} name={key} theme="rjv-default"  collapsed={2} enableClipboard={false} displayObjectSize={false} displayDataTypes={false}/>);

            }

            return (
                <tr key={key}>
                    <td className='row' >{key}</td>
                    <td  id={'attrValue:' + key} >
                        {attrValue}
                    </td></tr>
            );

        });

        if(operation.action === 'get'){

            return(<div>
                <Lookup />
                <br/>

                <table className='itemPanel' >
                    <tbody>
                    {attrMap2}
                    </tbody>
                </table>


            </div>);
        } else {
            return null;
        }

    }



};